const plantQuestions = [
    {
        id: 1,
        title: 'Do my plants need sunlight?',
        answer: 'Yes, most plants require sunlight for photosynthesis, a process that helps them produce food. Make sure to place your plants in locations where they can receive adequate sunlight based on their specific needs. If you have indoor plants, consider placing them near windows or using artificial grow lights.',
    },
    {
        id: 2,
        title: 'How often should I water my plants?',
        answer: "The frequency of watering depends on the type of plant, its size, and the environmental conditions. Generally, it's essential to keep the soil consistently moist but not waterlogged. Check the specific watering requirements for each plant species, and adjust based on factors like humidity and temperature.",
    },
    {
        id: 3,
        title: 'What are common pests for indoor plants?',
        answer: 'Common pests for indoor plants include spider mites, aphids, and mealybugs. Inspect your plants regularly for any signs of infestation, such as discolored leaves or small insects. Use natural remedies or insecticidal soaps to control pests, and isolate affected plants to prevent the infestation from spreading.',
    },
    {
        id: 4,
        title: 'Can I use any soil for my plants?',
        answer: 'Choosing the right soil is crucial for plant health. Different plants have different soil preferences. Some may prefer well-draining soil, while others thrive in more moisture-retentive mixtures. Research the specific soil requirements for your plants and select a high-quality potting mix or create a custom blend to meet their needs.',
    },
    {
        id: 5,
        title: 'How do I promote blooming in flowering plants?',
        answer: 'To promote blooming in flowering plants, ensure they receive adequate sunlight, provide the right nutrients (especially phosphorus), and deadhead spent flowers regularly. Some plants may benefit from specific fertilizers formulated to encourage blooming. Understand the specific needs of your flowering plants to enhance their blooming potential.'
    }
];

export default plantQuestions;
